import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=6261480f&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6261480f')) {
      api.createRecord('6261480f', component.options)
    } else {
      api.reload('6261480f', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=6261480f&", function () {
      api.rerender('6261480f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/tabs.vue"
export default component.exports